import React from 'react';
import {Container, Row, Col} from 'react-grid-system';
import AndroidLogo from './android/AndroidLogo';
import SectionDescription from './general/SectionDescription';
import QRCode from "./general/QRCode";
import {LinkProvider} from "../../../../res/LinkProvider";
import {getMobileOperatingSystem, OS} from "../../../../utils/CheckPlatform";

interface States {
}

interface Props {
}

class AndroidSection extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    getDescription = () => {
        let description = "Smartphone with Android version 4.1 (Jelly Bean, API 16) or major."

        if (getMobileOperatingSystem() === OS.unknow) {
            description += " To download app scan QRCode on left."
        }

        return description
    }

    render() {
        return (
            <section
                className={ getMobileOperatingSystem() === OS.unknow  ? "androidSectionBoth" : "androidSection"}>
                <Container>
                    <Row>
                        <QRCode
                            text={LinkProvider.latestAndroidApp}/>
                        <SectionDescription
                            title="Android"
                            description={this.getDescription()}/>
                        <AndroidLogo/>
                    </Row>
                </Container>
            </section>
        )
    }
}

export default AndroidSection;
